import React from 'react'
import PlayStore from '../../../assets/images/play-store.png'
import { ReactComponent as AppStore } from '../../../assets/svg/app-store.svg'

interface AppStoreLinksProps {
  /**
   * Google Play Store application link
   */
  apple: string
  /**
   * Apple App Store application link
   */
  google: string
}

export const AppStoreLinks = (props: AppStoreLinksProps) => {
  const { apple, google } = props

  // @ts-ignore
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  /**
   * If on an android device
   */
  if (/android/i.test(userAgent)) {
    return (
      <a style={{ width: 165 }} href={google}>
        <img width="100%" height="100%" src={PlayStore} />
      </a>
    )
  }

  /**
   * If on an apple device
   */
  // @ts-ignore
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return (
      <a href={apple}>
        <AppStore width={165} height={49.05} />
      </a>
    )
  }

  return (
    <div style={{ height: 50, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
      <a style={{ left: -8, position: 'relative' }} href={apple}>
        <AppStore width={165} height={50} />
      </a>
      <a href={google}>
        <img style={{ width: 165, height: 50 }} src={PlayStore} />
      </a>
    </div>
  )
}
